import { render, staticRenderFns } from "./ArticleSkeleton.vue?vue&type=template&id=110456c8&"
import script from "./ArticleSkeleton.vue?vue&type=script&lang=ts&"
export * from "./ArticleSkeleton.vue?vue&type=script&lang=ts&"
import style0 from "./ArticleSkeleton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SkeletonRect: require('/tmp/build_4600e676/src/components/skeleton/Rect.vue').default})
